import { Injectable } from '@angular/core';
import { SkyConfirmationDialogConfig } from './confirmation-dialog-config';
import { SkyConfirmationDialogInstance } from './confirmation-dialog.instance';
import { SkyModalService } from '../modal/modal.service';


export class SkyConfirmationDialogService {
  constructor(private modal: SkyModalService) {}

  public open(config: SkyConfirmationDialogConfig): SkyConfirmationDialogInstance {
    let instance = new SkyConfirmationDialogInstance();

    return instance.open(this.modal, config);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyModalService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
